import { Lock } from 'lucide-react'
import { cn } from '@/lib/cn'
import { Badge } from './Badge'
import { Text } from './Text'

interface LockedRegionProps {
  chipLabel: string
  description?: string
  className?: string
}

export function LockedRegion({ chipLabel, description, className }: LockedRegionProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-md bg-surface-muted px-4 py-6 text-center',
        className,
      )}
      aria-label={`${chipLabel}${description ? ` — ${description}` : ''}`}
    >
      <Badge variant="outline" className="gap-1.5">
        <Lock size={11} aria-hidden />
        {chipLabel}
      </Badge>
      <Text variant="body-sm" color="muted">
        —
      </Text>
      {description && (
        <Text variant="label-sm" color="subtle">
          {description}
        </Text>
      )}
    </div>
  )
}
